import { ReactElement, useEffect, useState } from "react";

type VisibilityGuardProps = {
  children: ReactElement;
  allowedProperties: any[];
  requestedProperties: any[];
};

export default function VisibilityGuard({
  children,
  allowedProperties = [],
  requestedProperties = [],
}: VisibilityGuardProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let intersection = requestedProperties.filter((p) =>
      allowedProperties.includes(p)
    );

    if (intersection.length > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [allowedProperties, requestedProperties]);

  return isVisible ? children : null;
}
